import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";
import CustomButton from "./CustomButton";

function OverviewCard({
  count,
  onClick,
  title,
  title2,
  countColor,
  loading,
  isMobile,
  hideBorder
}: any): JSX.Element {
  if (isMobile) return <div className={`p-3 ${hideBorder ? '' : 'border-b border-[#F0F0F0]'} w-full flex justify-between items-center`}>
    <div className="flex items-center gap-1">
      <CustomText text={count} fontWeight="font-medium" className="text-primary min-w-[15px]" fontSize="text-xs" />
      <CustomText text={title} fontWeight="font-medium" className="!text-[#001F53] " fontSize="text-xs" />
    </div>
    <Button
      buttonTheme="transparent"
      type='button'
      className="text-primary normal-case"
      textInformation={{
        text: 'View',
        fontWeight: 'font-normal',
        fontSize: 'text-xs',
        className: '!text-primary',
        fontColor: '!text-primary'
      }} onClick={onClick} />
  </div>

  return (
    <div
      className={`hover:border-[#18B5B7] flex ${title?.includes("Completed Orders") ? "py-9" : "py-12"
        } justify-center items-center border shadow-[0_0_6px_rgba(100,113,136,0.36)] rounded-2xl bg-white w-[100%] md:w-[45%] lg:w-[40%] text-center overflow-auto`}
    >
      <div>
        <h5
          className={`text-5xl ${countColor ?? "text-royalBlue"} font-semibold`}
        >
          {loading ? (
            <div className="h-8 w-24 bg-gray-300 animate-pulse rounded-md mb-2"></div>
          ) : (
            count
          )}
        </h5>
        <p className="text-sm text-royalBlue mb-1 font-semibold whitespace-nowrap">
          {loading ? (
            <div className="h-3 w-24 bg-gray-300 animate-pulse rounded-md mb-2" />
          ) : (
            title
          )}
        </p>
        {title2 && (
          <p className="text-sm text-royalBlue mb-1 font-semibold whitespace-nowrap">
            {loading ? (
              <div className="h-3 w-24 bg-gray-300 animate-pulse rounded-md mb-2" />
            ) : (
              title2
            )}
          </p>
        )}
        <div className="mb-6">
          {loading ? (
            <div className="h-3 w-24 bg-gray-300 animate-pulse rounded-md" />
          ) : (
            <Button
              buttonTheme="transparent"
              onClick={onClick}
              textInformation={{
                text: "View orders",
                fontWeight: "font-semibold",
              }}
              className={`text-sm hover:text-[#78dbdc] text-primary`}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default OverviewCard;